var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6693 3C14.6693 2.44772 14.2216 2 13.6693 2H2.33594C1.78365 2 1.33594 2.44772 1.33594 3V11C1.33594 11.5523 1.78365 12 2.33594 12H3.69933C4.05092 12 4.33594 12.285 4.33594 12.6366V12.6366C4.33594 13.1099 4.83397 13.4177 5.25725 13.206L7.45812 12.1056C7.59698 12.0361 7.75009 12 7.90534 12H13.6693C14.2216 12 14.6693 11.5523 14.6693 11V3Z",
    stroke: "url(#paint0_linear_13792_96133)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66406 6.5V7.5",
    stroke: "url(#paint1_linear_13792_96133)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.5V7.5",
    stroke: "url(#paint2_linear_13792_96133)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 6.5V7.5",
    stroke: "url(#paint3_linear_13792_96133)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13792_96133",
    x1: 8.0026,
    y1: 2,
    x2: 8.0026,
    y2: 13.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_13792_96133",
    x1: 5.16406,
    y1: 6.5,
    x2: 5.16406,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_13792_96133",
    x1: 8.5,
    y1: 6.5,
    x2: 8.5,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_13792_96133",
    x1: 11.8359,
    y1: 6.5,
    x2: 11.8359,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C54EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#684BF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiChat);
export default __webpack_public_path__ + "static/media/hi-chat.1ea9d24f3859d1c7a6dfe39b1b598b65.svg";
export { ForwardRef as ReactComponent };